import { AABBModel } from './AABBModel';

export enum EnvironmentTypeEnum {
    none = 'none',
    decor_plant = 'decor_plant',
    chair_left = 'chair_left',
    chair_right = 'chair_right',
    garbage = 'garbage',
    sofa = 'sofa',
    table = 'table',
    desk_left = 'desk_left',
    desk_right = 'desk_right',
    boiler = 'boiler',
    banking_left = 'banking_left',
    banking_front = 'banking_front',
    'table_bottom' = 'table_bottom',
    'table_l_2' = 'table_l_2',
    'table_top' = 'table_top',
    'table_l' = 'table_l',
    'desk' = 'desk',
    'plant_bottom' = 'plant_bottom',
    'plant_l_1' = 'plant_l_1',
    'plant_l_2' = 'plant_l_2',
    'sofa_bottom' = 'sofa_bottom',
    'sofa_top' = 'sofa_top',
    'boiler_2' = 'boiler_2',
    'chair_3' = 'chair_3',
    'chair_4' = 'chair_4',
    'chair_5' = 'chair_5',
    'chair_6' = 'chair_6',
    'wall_1' = 'wall_1',
    'wall_2' = 'wall_2',
    'wall_3' = 'wall_3',
    'glass_door' = 'glass_door',
    'corner_table' = 'corner_table',
    'table_server_room' = 'table_server_room',
    'server_1' = 'server_1',
    'server_2' = 'server_2',
    'server_3' = 'server_3',
    'table_security_1' = 'table_security_1',
    'table_security_2' = 'table_security_2',
    'socket' = 'socket',
    'sofa_security' = 'sofa_security',
    'sofa_security_2' = 'sofa_security_2',
    'cash' = 'cash',
    'sofa_cashroom' = 'sofa_cashroom',
    'table_cashroom' = 'table_cashroom',
    'plant_0' = 'plant_0',
    'cupboard_1' = 'cupboard_1',
    'cupboard_2' = 'cupboard_2',
    'cupboard_3' = 'cupboard_3',
    'cupboard_4' = 'cupboard_4',
    'cupboard_5' = 'cupboard_5',
    'cupboard_6' = 'cupboard_6',
    'cupboard_7' = 'cupboard_7',
    'cupboard_8' = 'cupboard_8',
    'cupboard_9' = 'cupboard_9',
    'table_archive' = 'table_archive',
    'safe' = 'safe',
    'table_storage' = 'table_storage',
    'cells' = 'cells',
    'plant_office1' = 'plant_office1',
    'plant_office2' = 'plant_office2',
    'chair_7' = 'chair_7',
    'chair_8' = 'chair_8',
    'table_office1' = 'table_office1',
    'table_office2' = 'table_office2',
    'table_office3' = 'table_office3',
    'table_office4' = 'table_office4',
    'table_room17' = 'table_room17',
    'boiler_corridor' = 'boiler_corridor',
    'plant_head_office' = 'plant_head_office',
    'sofa_head_office' = 'sofa_head_office',
    'table_head_office' = 'table_head_office',
    'boiler4' = 'boiler4',
    'chair_call_centre1' = 'chair_call_centre1',
    'chair_call_centre2' = 'chair_call_centre2',
    'chair_call_centre3' = 'chair_call_centre3',
    'plant_call_centre1' = 'plant_call_centre1',
    'plant_call_centre2' = 'plant_call_centre2',
    'plant_call_centre3' = 'plant_call_centre3',
    'table_call_centre1' = 'table_call_centre1',
    'table_call_centre2' = 'table_call_centre2',
    'table_call_centre3' = 'table_call_centre3',
    'table_call_centre4' = 'table_call_centre4',
    'box1' = 'box1',
    'box2' = 'box2',
    'box3' = 'box3',
    'cupboard_utility_room' = 'cupboard_utility_room',
    'table_utility_room' = 'table_utility_room',
    'garbage2' = 'garbage2',
    'bin' = 'bin',
    'buffet' = 'buffet',
    'chair1_24' = 'chair1_24',
    'chair2_24' = 'chair2_24',
    'chair3_24' = 'chair3_24',
    'chair4_24' = 'chair4_24',
    'chair5_24' = 'chair5_24',
    'kitchen_cupboard2' = 'kitchen_cupboard2',
    'kitchen_table' = 'kitchen_table',
    'plant24' = 'plant24',
    'table24' = 'table24',
    'char_call_centre1' = 'char_call_centre1',
    'char_call_centre2' = 'char_call_centre2',
    'char_call_centre3' = 'char_call_centre3',
    'closet_vault' = 'closet_vault',
}

export class EnvironmentModel extends AABBModel {
    public visible: boolean = false;
    public key: string = '';

    public constructor(public type: EnvironmentTypeEnum) {
        super();

        this.padding = [-50, 0];
        this.height = 200;
        this.width = 200;
    }
}
